/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { msalReady } from "./auth/msalConfig";

function renderApp() {
  const elem = document.getElementById("root")!;
  const app = (
    <StrictMode>
      <App />
    </StrictMode>
  );

  if (import.meta.hot) {
    const root = (import.meta.hot.data.root ??= createRoot(elem));
    root.render(app);
  } else {
    createRoot(elem).render(app);
  }
}

// Wait for MSAL to initialize and process any redirect response before rendering.
// If MSAL fails (e.g. corrupt cache), render the app anyway — the error boundary
// and auth guards will handle the unauthenticated state gracefully.
msalReady.then(renderApp).catch((err) => {
  console.error("MSAL initialization failed:", err);
  renderApp();
});
